import { render } from "./dataTableFooter.vue?vue&type=template&id=c808b936&scoped=true"
import script from "./dataTableFooter.vue?vue&type=script&lang=js"
export * from "./dataTableFooter.vue?vue&type=script&lang=js"

import "./dataTableFooter.vue?vue&type=style&index=0&id=c808b936&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c808b936"]])

export default __exports__